import EMailIcon from './component'

export default EMailIcon
